
import { calendarCategories } from '../../../mocks/calendarEvents';

interface CategoryFilterProps {
  selected: string;
  onSelect: (value: string) => void;
}

export default function CategoryFilter({ selected, onSelect }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {calendarCategories.map((cat) => {
        const isActive = selected === cat.value;
        return (
          <button
            key={cat.value}
            onClick={() => onSelect(cat.value)}
            className={`flex items-center space-x-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              isActive
                ? 'bg-teal-600 text-white shadow-md'
                : 'bg-white text-gray-600 border border-gray-200 hover:border-teal-300 hover:text-teal-600'
            }`}
          >
            <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
            <span>{cat.label}</span>
          </button>
        );
      })}
    </div>
  );
}
